import { Layout } from "../components/Layout";
import { Card } from "../components/Card";
import "./LegalPage.css";

export function TermsPage() {
  return (
    <Layout>
      <div style={{ marginBottom: "var(--space-5)" }}>
        <span className="label">Effective May 2026</span>
        <h1 style={{ marginTop: "6px" }}>Terms of Service</h1>
      </div>
      <Card>
        <article className="legal">
          <p>
            By creating an account and using the Retrofit AI Monitor service ("the Service") provided by Retrofit AI
            Systems, you agree to these terms.
          </p>

          <h2>1. The Service</h2>
          <p>
            The Service polls Meta's Marketing API on a schedule, evaluates your configured rules against the returned
            performance metrics, and notifies you via your chosen channels when a threshold is crossed. The Service is
            read-only — it does not pause campaigns, change budgets, or take any other action on your Meta ad accounts.
          </p>

          <h2>2. Eligibility and account responsibility</h2>
          <p>
            You must be authorized to grant access to the Meta Business Manager and ad accounts you connect. You are
            responsible for keeping your sign-in credentials and any linked notification channels (e.g., Telegram chat
            IDs, email recipients) confidential.
          </p>

          <h2>3. Acceptable use</h2>
          <p>
            You agree not to use the Service to monitor ad accounts you are not authorized to access, to attempt to
            bypass the Service's tenant isolation, or to attempt to reverse-engineer or stress-test the Service in ways
            that interfere with other users.
          </p>

          <h2>4. Fees</h2>
          <p>
            Initial early-access accounts may be provided free of charge. Once paid pricing is announced, current
            customers will be notified at least 30 days in advance of any change. Continued use after the effective date
            constitutes acceptance.
          </p>

          <h2>5. Data ownership</h2>
          <p>
            You own your data. We own the Service. The performance data the Service stores is yours; the rules engine,
            the dashboard, the codebase, and the trained heuristics are ours.
          </p>

          <h2>6. No warranty on alerts</h2>
          <p>
            The Service polls Meta on a schedule (currently every six hours for full insights and every three hours for
            delivery checks). Alerts are best-effort and may be delayed by Meta API rate limits, network failures, or
            the schedule itself. The Service is not a real-time guarantee that your campaigns are performing as
            expected, and you should not rely on the absence of an alert as confirmation that no problem exists.
          </p>

          <h2>7. Suspension and termination</h2>
          <p>
            We may suspend or terminate your account if you violate these terms, if Meta revokes our app's permissions,
            or if you request cancellation. On termination, your data is deleted within 30 days unless you request
            export first.
          </p>

          <h2>8. Limitation of liability</h2>
          <p>
            To the maximum extent permitted by law, Retrofit AI Systems is not liable for any indirect, incidental, or
            consequential damages arising from your use of the Service, including but not limited to lost advertising
            revenue, missed alerts, or business interruption. Our total liability in any case shall not exceed the fees
            you paid in the trailing 12 months.
          </p>

          <h2>9. Changes to these terms</h2>
          <p>
            We may revise these terms; the date at the top reflects the latest revision. Material changes will be
            emailed to account owners at least 14 days before they take effect.
          </p>

          <h2>10. Contact</h2>
          <p>
            Questions about these terms:{" "}
            <a href="mailto:privacy@retrofitaisystems.com">privacy@retrofitaisystems.com</a>.
          </p>
        </article>
      </Card>
    </Layout>
  );
}
